import Abstract from "../../abstract-view/abstract.js";

export default class Thumbs extends Abstract {
  constructor(element) {
    super();

    this._element = element;
  }

  getThumbs() {
    return this._element.querySelectorAll(`.product-gallery-thumb`);
  }

  setActiveThumb(activeIndex = 0) {
    Array.from(this.getThumbs())
      .forEach((element, index) => {
        if (index === activeIndex) {
          element.classList.add(`${element.classList[0]}_active`);
        } else {
          element.classList.remove(`${element.classList[0]}_active`);
        }
      });
  }
}
